import { ImagePlus } from "lucide-react";

export function CardMediaSlot({ image, label, testId, className = "" }) {
  const safeLabel = label || "Media slot";
  return (
    <div className={`card-media-slot ${className}`.trim()} data-testid={testId}>
      {image ? (
        <img src={image} alt={safeLabel} data-testid={`${testId}-image`} />
      ) : (
        <>
          <ImagePlus size={20} aria-hidden="true" />
          <span data-testid={`${testId}-placeholder`}>{safeLabel}</span>
        </>
      )}
    </div>
  );
}